module.exports = __webpack_public_path__ + "img/bg2.3037d83e.png";